// extracted by mini-css-extract-plugin
export default {"full-page":"full-page-875d"};